/**
 * 一度だけ発火するイベントリスナーを付与する
 * @param element HtmlElement
 * @param type string event type
 * @param listener function event listener function
 * @param args rest of addEventListener args
 */
export default function (element, type, listener, ...args) {
  const onceEventListener = (...elArgs) => {
    listener.call(element, ...elArgs);
    element.removeEventListener(type, onceEventListener);
  };
  element.addEventListener(type, onceEventListener, ...args);
}
